<template>
    <div :class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="card widget-flat">
                    <loading-animation :active.sync="loading" :is-full-page="false" :opacity="1" color="#5895ff" />
                    <div class="card-body px-3 py-4">
                        <h5 class="text-muted fw-normal mt-0" title="Famílias">Famílias</h5>
                        <div class="float-start mr-2">
                            <i class="mdi mdi-account-group widget-icon"></i>
                        </div>
                        <h3 style="line-height: 30px" v-if="report.familias > 0">
                            {{ report.familias | maskNumber }}
                        </h3>
                        <h3 style="line-height: 30px" v-else>0</h3>
                    </div>
                    <!-- end card-body-->
                </div>
                <!-- end card-->
            </div>
            <!-- end col-->

            <div class="col-lg-6">
                <div class="card widget-flat">
                    <loading-animation :active.sync="loading" :is-full-page="false" :opacity="1" color="#5895ff" />
                    <div class="card-body px-3 py-4">
                        <h5 class="text-muted fw-normal mt-0" title="Usuários">Usuários</h5>
                        <div class="float-start mr-2">
                            <i class="mdi mdi-account widget-icon"></i>
                        </div>
                        <h3 style="line-height: 30px" v-if="report.usuarios > 0">
                            {{ report.usuarios | maskNumber }}
                        </h3>
                        <h3 style="line-height: 30px" v-else>0</h3>
                    </div>
                    <!-- end card-body-->
                </div>
                <!-- end card-->
            </div>
            <!-- end col-->
        </div>
        <!-- end row -->

        <div class="row">
            <div class="col-lg-6">
                <div class="card widget-flat">
                    <loading-animation :active.sync="loading" :is-full-page="false" :opacity="1" color="#5895ff" />
                    <div class="card-body px-3 py-4">
                        <h5 class="text-muted fw-normal mt-0" title="Atendimentos">Atendimentos</h5>
                        <div class="float-start mr-2">
                            <i class="mdi mdi-message-draw widget-icon"></i>
                        </div>
                        <h3 style="line-height: 30px" v-if="report.atendimentos > 0">
                            {{ report.atendimentos | maskNumber }}
                        </h3>
                        <h3 style="line-height: 30px" v-else>0</h3>
                    </div>
                    <!-- end card-body-->
                </div>
                <!-- end card-->
            </div>
            <!-- end col-->

            <div class="col-lg-6" v-if="$store.state.user.role_details.name != 'Nível Básico'">
                <div class="card widget-flat">
                    <loading-animation :active.sync="loading" :is-full-page="false" :opacity="1" color="#5895ff" />
                    <div class="card-body px-3 py-4">
                        <h5 class="text-muted fw-normal mt-0" title="Encaminhamentos">
                            Encaminhamentos
                        </h5>
                        <div class="float-start mr-2">
                            <i class="mdi mdi-sync widget-icon"></i>
                        </div>
                        <h3 style="line-height: 30px" v-if="report.encaminhamentos > 0">
                            {{ report.encaminhamentos | maskNumber }}
                        </h3>
                        <h3 style="line-height: 30px" v-else>0</h3>
                    </div>
                    <!-- end card-body-->
                </div>
                <!-- end card-->
            </div>
            <!-- end col-->
        </div>
        <!-- end row -->
    </div>
</template>
<script>
export default {
    name: 'ContadorEntidade',
    props: ['loading', "report", "container"]
}
</script>